import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import useLoading from '@hooks/ui/useLoading';
import { useFlow } from '@stackflow/react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useRegisterPin() {
    const { t } = useTranslation('easyCard');
    const { startLoading, stopLoading } = useLoading();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: KiccEasyCardApi.registerPin,
        onMutate() {
            startLoading();
        },
        onSuccess() {
            toast.success(t('pin.success'));
            pop();
        },
        onError(e) {
            console.error(e);
            toast.error(t('pin.error'));
        },
        onSettled() {
            stopLoading();
        },
    });

    const handleRegisterPin = (pin: string) => {
        mutate({
            pin, checkPin: pin,
        });
    };

    return {
        handleRegisterPin,
    };
}

export default useRegisterPin;
